import Vue from 'vue'
import Vuex from 'vuex'
import sign from './module/sign'
import authentication from './module/authentication'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    sign,
    authentication,
  },
})
